module.exports = __webpack_public_path__ + "img/eced161.png";